<template>
    <zen-slide-in
        :isOpen="isOpen"
        title="Add contexts?"
        :error="error"
        @close="$emit('close')"
    >
        <div>
            <label
                for="context-search"
                class="block text-sm lg:text-base font-medium text-taupe-800"
                >Search</label
            >
            <div class="mt-1">
                <input
                    type="text"
                    name="segment-name"
                    id="context-search"
                    autocomplete="off"
                    :value="search"
                    @input="$emit('update:search', $event.target.value)"
                    class="block w-full rounded-md border-taupe-300 shadow-xs focus:border-taupe-500 focus:ring-taupe-500 sm:text-sm lg:text-base"
                />
            </div>
        </div>
        <zen-empty-table-message
            v-if="results.length == 0 && search === ''"
            compact
            icon="ZenIconUser"
        >
            Use the search above to find contexts to add to this segment.
        </zen-empty-table-message>
        <zen-empty-table-message
            v-if="results.length == 0 && search !== ''"
            compact
            icon="ZenIconUser"
        >
            There are no results for your search.
        </zen-empty-table-message>
        <div>
            <ul class="divide-y divide-taupe-100">
                <li
                    v-for="context in results"
                    :key="contextRowKey(context)"
                    class="flex gap-x-4 py-5"
                >
                    <zen-add-button
                        :label="context.name || context.identifier"
                        :busy="isAddingContext(context)"
                        :disabled="adding"
                        @click="$emit('add', context)"
                    />
                    <div class="min-w-0">
                        <p class="text-sm font-medium leading-6 text-taupe-800">
                            {{ context.name }}
                        </p>
                        <p class="mt-1 text-xs leading-5 text-taupe-500">
                            <zen-inline-pill
                                v-if="isPersistedContext(context)"
                                :value="context.type"
                            />
                            <span
                                v-else
                                class="text-xs font-medium uppercase text-amber-700"
                            >
                                Will be created
                            </span>
                        </p>
                    </div>
                </li>
            </ul>
        </div>
        <template v-slot:buttons>
            <zen-button variant="secondary" @click="$emit('close')">
                Done
            </zen-button>
        </template>
    </zen-slide-in>
</template>

<script>
export default {
    name: 'AddSegmentContextsSlideIn',
    props: {
        isOpen: {
            type: Boolean,
            required: true,
        },
        search: {
            type: String,
            default: '',
        },
        error: {
            type: [String, Object],
            default: null,
        },
        adding: {
            type: Boolean,
            default: false,
        },
        // Row key of the context currently being added, so only that row
        // shows the spinner while every other add button is just disabled.
        addingKey: {
            type: String,
            default: null,
        },
        results: {
            type: Array,
            required: true,
        },
        contextRowKey: {
            type: Function,
            required: true,
        },
        isPersistedContext: {
            type: Function,
            required: true,
        },
    },
    emits: ['close', 'add', 'update:search'],
    methods: {
        isAddingContext(context) {
            return this.adding && this.contextRowKey(context) === this.addingKey
        },
    },
}
</script>
